import React, { useState, useEffect } from "react";
// import '../../styles/MainDishes.css';
import '../../styles/MenuItems.css';
import '../../styles/Styles.css';

function MainDishes() {

    const [mainDishes, setMainDishes] = useState([]);

    useEffect(() => {
        fetch('https://strapi.restauracjasamiswoi.pl/api/categories?populate=menu_items')
        .then(response => response.json())
        .then(data => {
            const category = data.data.find(item => item.name === 'DANIA GŁÓWNE');

            if (category) {
                setMainDishes(category.menu_items);
            };
        });
    }, [])

    return (
        <div className="container-fluid section-green-background">
            <div className="container section-menu-item">
                <div className="dish-photo-container-20">
                    <img src={require("../../assets/menu/main-dish.webp")} className="dish-photo-main-dishes img-menu img-rounded shadow" />
                </div>
                <div className="menu-right-75">
                    <div className="menu-item-title-section d-flex justify-content-between align-items-end">
                    <p className="menu-item-title-font fs-1 m-0 fw-bold item-title">DANIA GŁÓWNE</p>
                    </div>
                    <hr/>
                    {mainDishes.map((mainDish) => (
                        <div key={mainDish.id} className="container">
                            <div className="dish-name-container d-flex justify-content-between">
                                <p className="menu-item-title-font fs-5 m-0">{mainDish.name}</p>
                                <p className="fs-5 m-0">{mainDish.price}zł</p>
                            </div>
                            <p className="ingridients-container fs-6 m-0 fw-lighter">{mainDish.ingredients}</p>
                            <div className="mb-3 mt-3 divide-line divide-line-white"/>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )

}

export default MainDishes;

